function imgChange (url, obj) {
  let res = "";
  return res = ajax_post(url, obj)
}

function ajax_post(url, obj){
  return new Promise(
  function (resolve, reject) {
    var ajax = new XMLHttpRequest();
      ajax.open('post',url);
      ajax.setRequestHeader("Content-type","application/x-www-form-urlencoded");
      if(obj){
        ajax.send(new URLSearchParams(obj));
      }else{
        ajax.send();
      }
      ajax.onreadystatechange=function(){
        if(ajax.readyState==4&&ajax.status==200){
          resolve(JSON.parse(ajax.responseText))
      }
    }
  })
}
export default imgChange;